<template>
  <div id="notePan">
    <el-dialog
      title="标 注"
      v-model="dialogVisible"
      :modal="false"
      @open="onOpen"
      @close="onClose"
    >
      <el-form
        ref="elForm"
        :model="formData"
        :rules="rules"
        size="medium"
        label-width="100px"
      >
        <el-form-item label-width="0" prop="noteinfo">
          <el-input
            v-model="formData.noteinfo"
            type="textarea"
            placeholder="请在此输入..."
            :autosize="{ minRows: 4, maxRows: 6 }"
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div>
          <el-button v-if="showAdd" @click="close">取消</el-button>
          <el-button v-if="showAdd" @click="addNote">添加</el-button>
          <el-button v-if="showOperate" @click="delNote">删除</el-button>
          <el-button v-if="showOperate" @click="updateNote">修改</el-button>
          <el-button v-if="showOperate" @click="close">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  emits: ['initNotesEvent', 'delNoteEvent', 'updateNoteEvent'],
  data () {
    return {
      showAdd: false,
      showOperate: false,
      dialogVisible: false,
      imageId: '',
      formData: {
        noteinfo: ''
      },
      rules: {
        noteinfo: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ]
      },
      x: 0,
      y: 0,
      unId: 0,
      ipos: 0 // 编辑或删除状态 本页数据在数组中的索引位置
    }
  },
  methods: {
    onOpen () {},
    onClose () {
      this.$refs.elForm.resetFields()
    },
    close () {
      this.dialogVisible = false
    },
    showAddNotePan (imgid, flagX, flagY) {
      this.x = flagX
      this.y = flagY
      this.showAdd = true
      this.showOperate = false
      this.imageId = imgid
      this.dialogVisible = true
    },
    showOpNotePan (index, imgid, objv) {
      this.ipos = index
      this.formData.noteinfo = ''
      if (objv != null) {
        this.formData.noteinfo = objv.info
        this.x = objv.x
        this.y = objv.y
        this.unId = objv.unId
      }
      // info:relX:relY:unId:
      this.showAdd = false
      this.showOperate = true
      this.imageId = imgid
      this.dialogVisible = true
    },
    addNote () {
      this.$refs.elForm.validate(valid => {
        if (!valid) {
          return
        }
        this.saveNote()
      })
    },
    delNote () {
      // let mirro = this
      this.$confirm('确定删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const api = '/md/front/additional/notation/delOneAnnotation'
          const params = {
            unId: this.unId
          }
          this.axios.post(api, this.$stringify(params)).then(res => {
            if (res.status === 200) {
              this.dialogVisible = false
              this.formData.noteinfo = ''
              this.$emit('delNoteEvent', this.ipos)
            }
          })
        }).catch(action => {})
    },
    saveNote () {
      // 正式添加签注
      const api = '/md/front/additional/notation/newPointLocation'
      const params = {
        imageId: this.imageId,
        notationInfo: this.formData.noteinfo,
        x: this.x,
        y: this.y
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.dialogVisible = false
          this.$refs.elForm.resetFields()
          this.showNotes(this.imageId) // 加载当前页的标注
        }
      })
    },
    updateNote () {
      this.$refs.elForm.validate(valid => {
        if (!valid) return
        const api = '/md/front/additional/notation/editAnnotationInfo'
        const params = {
          unId: this.unId,
          notationInfo: this.formData.noteinfo,
          x: this.x,
          y: this.y
        }
        this.axios.post(api, this.$stringify(params)).then(res => {
          if (res.status === 200) {
            this.dialogVisible = false
            this.$emit('updateNoteEvent', this.ipos, this.formData.noteinfo)
            this.formData.noteinfo = ''
          }
        })
      })
    },
    showNotes (imageid) {
      const api = '/md/front/additional/notation/showAllAnnotationsInPic'
      const params = {
        imageId: imageid
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.$emit('initNotesEvent', res.data)
        }
      })
    },
    loadNotes (imageid) {
      const api = '/md/front/additional/notation/showAllAnnotationsInPic'
      const params = {
        imageId: imageid
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.$emit('initNotesEvent', res.data)
        }
      })
    }

  }
}
</script>
<style scoped>
#notePan :deep(.el-dialog) {
  width: 30%;
}
</style>
